$(document).ready(function() {

  function updatePrice(){
    var VAT = 20;
    var $price = parseFloat($('#ProductPrice').text().replace('£', ''));
    var $total = $price * ((100 + VAT) / 100);
    var $plusvat = $total.toFixed(2);
    $('.priceUpdate').text('(Price inc VAT: £'+$plusvat+')');
  }
  $('#AddToCartForm select').on('change', function(){
    updatePrice();
  });
  updatePrice();
});